import { Box } from '../../common/ui/Box';
import { Text } from '../Text/Text';

import { CalloutProps } from './Callout';

interface CalloutContentProps extends Pick<CalloutProps, 'heading' | 'description' | 'Icon'> {
    color: string;
}

export const CalloutContent = ({ heading, description, Icon, color }: CalloutContentProps) => {
    const renderedLeadingVisual = Icon ? <Icon height={16} width={16} color={color} /> : null;
    return (
        <Box
            display="grid"
            gridTemplateColumns={renderedLeadingVisual ? '16px auto' : 'auto'}
            columnGap={16}
            rowGap={4}
            paddingRight={24}
        >
            {renderedLeadingVisual}

            {heading ? <Text variant="subtitle2">{heading}</Text> : null}

            {description ? (
                <Text
                    variant="extraSmall"
                    color={heading ? 'foreground.muted' : color}
                    style={{ gridColumnStart: renderedLeadingVisual ? 2 : 0 }}
                >
                    {description}
                </Text>
            ) : null}
        </Box>
    );
};
